import PlayerConsentCard from './PlayerConsentCard.svelte';
import PlayerConsentLoader from './PlayerConsentLoader.svelte'
!customElements.get('player-consent-card') && customElements.define('player-consent-card', PlayerConsentCard);
!customElements.get('player-consent-loader') && customElements.define('player-consent-loader', PlayerConsentLoader);
export default PlayerConsentCard;
